import { styled } from 'styled-components';

export const SelectionPage = styled.div`
  padding: 20px;
  color: #2d3748;
  width: 100%;

  h2 {
    color: #2d3748;
    font-weight: 600;
  }
`;

export const SelectionStatus = styled.span`
  color: #9333ea;
  font-weight: 600;
`;

export const SelectionGrowStatus = styled.span`
  color: #10b981;
  font-weight: 600;
`;

export const TabBar = styled.div`
  display: flex;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 20px;
`;

export const Tab = styled.button<{ $active: boolean }>`
  padding: 10px 20px;
  cursor: pointer;
  background-color: ${props => props.$active ? '#ffffff' : 'transparent'};
  color: #2d3748;
  border: none;
  border-bottom: 3px solid ${props => props.$active ? '#4299e1' : 'transparent'};
  transition: all 0.3s;

  &:hover {
    background-color: #f7fafc;
  }
`;

export const TabContent = styled.div<{ $active: boolean }>`
  display: ${props => props.$active ? 'block' : 'none'};
`;

export const FormRow = styled.div`
  margin-bottom: 10px;
`;

export const FormInputNumber = styled.input.attrs({ type: 'number' })`
  margin-left: 10px;
  width: 80px;
`;

export const FormCheckbox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 5px;
`;

export const FormSubmit = styled.input.attrs({ type: 'submit' })`
  margin-top: 10px;
  padding: 8px 16px;
  background-color: #4299e1;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3182ce;
  }
`;
